import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  organizationId: null,
  target: null,
  fileName: null,
  isSubmitting: false,
  resultError: null,
  resultMessage: null,
}

const slice = createSlice({
  name: 'nettingUpdaterTools',
  initialState,
  reducers: {
    setOrganizationId: (state, { payload }) => {
      state.organizationId = payload ? Number(payload) : null
    },
    setTarget: (state, { payload }) => {
      state.target = payload || null
    },
    setFile: (state, { payload }) => {
      state.fileName = payload?.name || null
    },
    clearFile: state => {
      state.fileName = null
    },
    submitRequest: state => {
      state.isSubmitting = true
      state.resultError = null
      state.resultMessage = null
    },
    submitSuccess: (state, { payload }) => {
      state.isSubmitting = false
      state.resultError = null
      state.resultMessage = payload?.message || ''
    },
    submitFailure: (state, { payload }) => {
      state.isSubmitting = false
      state.resultError = payload?.error || 'Error'
      state.resultMessage = payload?.message || null
    },
    reset: state => {
      Object.assign(state, initialState, { target: state.target })
    },
  },
})

export const {
  setOrganizationId,
  setTarget,
  setFile,
  clearFile,
  submitRequest,
  submitSuccess,
  submitFailure,
  reset,
} = slice.actions

export default slice.reducer
